<template>
  <v-app :class="offline ? 'offline' : 'online'">
    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <div>
          <div class="status">
            <v-icon v-if="offline" class="status-icon">mdi-wifi-off</v-icon>
            <v-icon v-if="offline" class="status-icon">mdi-signal-off</v-icon>
            <v-icon v-if="!offline" class="status-icon">mdi-wifi</v-icon>
            <v-icon v-if="!offline" class="status-icon">mdi-signal</v-icon>
          </div>
          <div class="bark">
            <v-icon v-if="offline" class="icon" color="black">mdi-cloud-off-outline</v-icon>
            <v-icon v-if="!offline" class="icon" color="blue darken-2">mdi-cloud-outline</v-icon>

            <br /><span v-if="offline">You are currently Offline</span><span v-if="!offline">We are back Online!</span>
            <br /><br /><br />
            <br /><span v-if="offline">We'll keep checking your internet connection</span><span v-if="!offline">Taking you back to the Portal</span>
            <br /><span v-if="offline">Click below to check now</span>
          </div>
          <div class="check-internet">
            <v-btn text :disabled="checking || !offline" @click="check()" :ripple="true">
              <v-icon color="white" x-large v-if="checking && offline">mdi-timer-sand</v-icon>
              <v-icon color="white" x-large v-if="!checking && offline">mdi-refresh</v-icon>
              <v-icon color="white" x-large v-if="!offline">mdi-check</v-icon>
            </v-btn>
          </div>
        </div>
      </v-container>
    </v-main>
    <!--<v-footer align="center" app>
      <span class="footer-text" >Copyright {{ (new Date()).getFullYear() }}. "WIOM", "i2e1" are Trademarks of Omnia Information Pvt. Ltd.</span>
    </v-footer>-->
  </v-app>
</template>
<style scoped>
  .offline {
    background: #f06b69;
  }
  .online {
    background: #ee4b8d;
  }
  .footer-text {
    margin: 0px auto;
    font-size: 0.6em;
  }
  .bark {
    margin: 0px auto;
    text-align: center;
    margin-top: 25%;
    font-weight: bold;
  }
  .offline .bark {
    color: black;
  }
  .online .bark {
    color: white;
  }
  .bark > .icon{
    font-size: 96px;
  }
  .status {
    text-align: right;
  }
  .online .status .status-icon {
    color: white;
  }
  .offline .status .status-icon {
    color: black;
  }
  .check-internet {
    text-align: center;
    margin-top: 30px;
  }
</style>
<script>
import WIOM_APIS from './utils/wiom-apis';
export default {
  mounted: function() {
    let that = this;
    setTimeout(function () {
      that.check();
    }, 4000);
  },
  data: function() {
    return {
      offline: true,
      checking: false
    }
  },
  methods: {
    check: function() {
      let that = this;
      this.checking = true;
      WIOM_APIS.fetchUser().then(function(response) {
        if (response) {
          that.offline = false;
          setTimeout(() => {that.checking = false;}, 600);
          setTimeout(function () {
            that.$router.push('/').catch(()=>{});
          }, 2000);
        } else {
          setTimeout(() => {that.checking = false;}, 600);
          setTimeout(function() {
            that.check();
          }, 5000);
        }
      }).catch(() => {
        setTimeout(() => {that.checking = false;}, 600);
        setTimeout(function() {
          that.check();
        }, 5000);
      });
    }
  }
}
</script>